module.exports = __webpack_public_path__ + "static/media/cms-solutions-icon.4299c8a5.svg";